import { useRef } from "react"
import './styles.scss';
import { MinusIcon, PlusIcon } from "@phosphor-icons/react";
const AccordionItem = ({ question, answer, isOpen, onClick }) => {
  const contentHeight = useRef()
  return (
    <div className="wrapper" >
      <button className={`question-container ${isOpen ? 'active' : ''}`} onClick={onClick} >
        <p className='question-content'>{question}</p>
        {isOpen ? <MinusIcon size={24} /> : <PlusIcon size={24} />}
      </button>

      <div ref={contentHeight} className="answer-container" style={
        isOpen
          ? { height: contentHeight.current.scrollHeight }
          : { height: "0px" }
      }>
        <p className="answer-content"><div className='html-text' dangerouslySetInnerHTML={{ __html: answer }} /></p>
      </div>
    </div>
  )
}

export default AccordionItem;